<template>
  <div
    v-if="geoLocationAllowed && showDistanceData"
    :moduleInfo="moduleInfo"
    class="container max-w-screen-md lg:max-w-screen-xl mx-auto my-6"
  >
    <h2
      v-if="
        hasPropertyValue(
          'ModuleTitle',
          moduleInfo.Module.ModuleProperties,
          moduleData
        ) && distanceDataSuccessArr.length
      "
      class="pb-0 text-center md:text-left"
      :class="[{ 'mb-10px' : userCountry && moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False'}, (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'True' ? 'overtitle text-16' : 'headline-3a text-htz-red')]"
    >
      {{
        getPropertyValue($t,"ModuleTitle",moduleInfo.Module.ModuleProperties,moduleData)
      }}
    </h2>
    <p
      v-if="userCountry && moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False'"
      class="overtitle text-16 text-center md:text-left"
    >
      {{ $t("loc_distance_welcome") }}, {{ getUserCountry(userCountry) }}
    </p>

    <div v-if="gettingLocation">
      <div class="loader" />
    </div>

    
    <div v-if="gotDestination && gotCoordinates" :class="{
      'grid grid-cols-2 grid-rows-2 gap-x-46px lg:gap-x-60px gap-y-30px lg:gap-y-46px mt-22 md:mt-10': moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'True',
      'flex flex-wrap sm:flex-no-wrap items-start justify-around md:justify-start md:space-x-16 lg:space-x-32 xl:space-x-40 md:px-8 lg:px-16 pt-12': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === ''),
    }">
      <div v-for="currentDistance in calculatedDistance" :key="currentDistance.type"
        class="flex flex-col items-center text-center md:mb-0" :class="{
          'w-auto':
            moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'True',
          'mb-6 w-1/2 sm:w-auto': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === ''),
        }">
        <!-- <i
          v-if="currentDistance.duration !== ''"
          :class="'icon icon-' + currentDistance.icon + '-ico block md:min-h-20'
          "
        ><span
          class="path1 text-48"
          :class="{' text-60 md:text-80': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === '')}"
        /><span
          class="path2 text-48"
          :class="{'text-60 md:text-80': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === '')}"
        /><span
          class="path3 text-48"
          :class="{'text-60 md:text-80': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === '')}"
        /></i> -->
        <Icon
          v-if="currentDistance.duration !== ''"
          :icon-name="currentDistance.icon"
          :icon-class="'icon icon-' + currentDistance.icon + '-ico block md:min-h-20'"
          :span-class="isSidebarClass(moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar)"
        />
        <p
          v-if="currentDistance.duration !== ''"
          class="p-xs text-htz-steel uppercase"
          :class="{'mt-4': (moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === 'False' || moduleInfo.Module.ModuleProperties.ModuleShowAsSidebar === '')}"
        >
          {{ currentDistance.distance }}
        </p>
        <p
          v-if="currentDistance.duration !== ''"
          class="p-sm text-htz-red"
        >
          {{ currentDistance.duration }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMapsApiLoader from "google-maps-api-loader";
import {selfDataRequestMixin} from "@/mixins";
import Icon from "@/components/includes/Icon";

export default {
  name: "Distance",
  components: {
    Icon
  },
  mixins: [selfDataRequestMixin],
  props: {
    moduleInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // googleMapsApiKey: "",
      // destination: "",
      gettingLocation: false,
      geoLocationAllowed: true,
      hasCoordinates: false,
      distanceDataSuccessArr: [],
      showDistanceData: true,
      originCoord: [],
      userCountry: "",
      destinationCoord: [],
      calculatedDistance: [
        {
          name: "plane",
          type: "plane",
          icon: "plane",
          distance: "",
          duration: "",
        },
        {
          name: "car",
          type: "driving",
          icon: "car",
          distance: "",
          duration: "",
        },
        {
          name: "bus",
          type: "transit",
          icon: "bus",
          distance: "",
          duration: "",
        },
        {
          name: "bicycle",
          type: "bicycling",
          icon: "bike",
          distance: "",
          duration: "",
        },
      ],
    };
  },
  computed: {
    googleMapsApiKey () {
      return  this.$store.state.Params.find(o => o.Key === 'GoogleMapsAPIKey')?.Value ||  "";
    },
    planeSpeed () {
      return  this.$store.state.Params.find(o => o.Key === 'AirplaneSpeed')?.Value ||  "";
    },
    gotCoordinates: function () {
      if (this.hasCoordinates) {
        if (this.googleMapsApiKey) {
          this.loadGoogleMapsApi();
        }
        return true;
      }
      return false;
    },
    gotDestination: function () {
      if (this.destination) {
        this.getOriginsAndDestCoordinates();
        return true;
      }
      return false;
    },
    hasModulePropDestination() {
      return this.$filters.hasPropertyValue(
        "ModuleDestinationCoords",
        this.moduleInfo.Module.ModuleProperties,
        this.moduleInfo.Module
      )
    },
    destinationFromModuleProp () {
      return this.$filters.getPropertyValue(  this.$t,
        "ModuleDestinationCoords",
        this.moduleInfo.Module.ModuleProperties,
        this.moduleInfo.Module
      )
    },
    destinationFromParams() {
      return this.$store.state.Params.find(o => o.Key === 'DistanceDefaultDestinacija')?.Value || '';
    },
    destination() {
      return this.hasModulePropDestination ? this.destinationFromModuleProp : this.destinationFromParams;
    }
  },
  mounted() {
    /*this.$parameters.getParameter("GoogleMapsAPIKey", "").then((response) => {
      this.googleMapsApiKey = response;
    });*/
/*    if (
      this.$filters.hasPropertyValue(
        "ModuleDestinationCoords",
        this.moduleInfo.Module.ModuleProperties,
        this.moduleInfo.Module
      )
    ) {
      this.destination = this.$filters.getPropertyValue(  $t,
        "ModuleDestinationCoords",
        this.moduleInfo.Module.ModuleProperties,
        this.moduleInfo.Module
      );
    } else {
      this.$parameters
        .getParameter("DistanceDefaultDestinacija", "")
        .then((response) => {
          this.destination = response;
        });
    }*/
  },
  methods: {
    async calcDistance(calcDistanceObj) {
      let travelMode;
      let transitMode;
      switch (calcDistanceObj.type) {
        case "bicycling":
          travelMode = this.google.maps.TravelMode.BICYCLING;
          break;
        case "transit":
          travelMode = this.google.maps.TravelMode.TRANSIT;
          transitMode = {
            modes: [calcDistanceObj.name.toUpperCase()],
          };
          break;
        default:
          travelMode = this.google.maps.TravelMode.DRIVING;
          transitMode = null;
      }
      if(calcDistanceObj.type === "plane"){
        if(this.planeSpeed) {
          var airDistance = this.calcAirDistance(this.destinationCoord, this.originCoord);
          var airTime = this.calcAirTime(airDistance, +this.planeSpeed);

          calcDistanceObj.distance = `${airDistance} km`;
          calcDistanceObj.duration = this.$t("loc_distance_calculation", [
                this.convertTime(airTime * 60),
                this.$t(
                  this.$filters.stringFormat(
                    "loc_distance_{0}",
                    calcDistanceObj.name
                  )
                ),
              ]);
          this.showDistanceData = this.distanceDataSuccessArr.length > 0;
        }
        return true;
      } else {
        const service = new this.google.maps.DistanceMatrixService();
        return service.getDistanceMatrix(
          {
            origins: this.originCoord,
            destinations: this.destinationCoord,
            //london
            /* origins: ["51.552029,-0.298980"],
            destinations: ["51.507351,-0.127758"], */
            travelMode: travelMode,
            unitSystem: this.google.maps.UnitSystem.METRIC,
            transitOptions: transitMode,
          },
          (response, status) => {
            if (status !== "OK") {
              calcDistanceObj.distance = response.statusText;
            }
            if (status === "OK" && response.rows[0].elements[0].status === "OK") {
              this.getVisitorsCountry(response.originAddresses[0]);
              this.distanceDataSuccessArr.push(response.originAddresses[0]);
              calcDistanceObj.distance =
                response.rows[0].elements[0].distance.text;
              calcDistanceObj.duration = this.$t("loc_distance_calculation", [
                response.rows[0].elements[0].duration.text,
                this.$t(
                  this.$filters.stringFormat(
                    "loc_distance_{0}",
                    calcDistanceObj.name
                  )
                ),
              ]);
            } else {
              calcDistanceObj.distance = this.$t("loc_distance_not_reachable");
            }
            this.showDistanceData = this.distanceDataSuccessArr.length > 0;
            return true
          }
        ).then(() => true);
      }
    },
    getOriginsAndDestCoordinates() {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };
      this.gettingLocation = true;
      navigator.geolocation.getCurrentPosition(
        this.getCoordsSuccess,
        this.getCoordsError,
        options
      );
    },
    getCoordsSuccess(pos) {
      this.gettingLocation = false;
      const crd = pos.coords;
      this.originCoord.push(crd.latitude + "," + crd.longitude);
      this.destinationCoord.push(this.destination);
      this.hasCoordinates = true;
    },
    getCoordsError() {
      this.gettingLocation = false;
      this.geoLocationAllowed = false;
      this.hasCoordinates = false;
    },
    getVisitorsCountry(res) {
      let resArray = res.split(",");
      this.userCountry = res.split(",")[resArray.length - 1];
      this.setCookie('userFromCountry', this.userCountry)
    },
    async loadGoogleMapsApi() {
      this.google = await GoogleMapsApiLoader({
        apiKey: this.googleMapsApiKey,
        language: this.$store.state.PageData.LanguageId,
      });
      if (this.getCookie('distance' + this.destination)) {
        this.calculatedDistance = this.getCookie('distance' + this.destination);
        if(this.getCookie('distanceName' + this.destination)){
          this.distanceDataSuccessArr = this.getCookie('distanceName' + this.destination);
        }
        if(this.getCookie('userFromCountry')){
          this.userCountry = this.getCookie('userFromCountry');
        }
      } else {
        await this.asyncForEach(this.calculatedDistance, async (obj) => {
          await this.calcDistance(obj);
        })
        this.setCookie('distance' + this.destination, this.calculatedDistance, 8);
        this.setCookie('distanceName' + this.destination, this.distanceDataSuccessArr, 8);
      }
    },

    getUserCountry(userCountry){
      const userCountryWithoutNumbers = userCountry.replace(/\d+/g, '');
      if(userCountryWithoutNumbers != ' '){
        return userCountryWithoutNumbers;
      } else {
        return this.$t("loc_distance_default_country");
      }
    },
    isSidebarClass(isSidebar){
      if(isSidebar === 'True'){ return 'text-48 '; }
      else return 'text-60 md:text-80 ';
    },
    calcAirDistance(dest, origin) {
      if(dest.length > 0 && origin.length > 0) {
        var destCoord = dest[0].split(',');
        var originCoord = origin[0].split(',');
        var R = 6371.0710; // Radius of the Earth in km
        var rlat1 = +destCoord[0] * (Math.PI/180); // Convert degrees to radians
        var rlat2 = +originCoord[0] * (Math.PI/180); // Convert degrees to radians
        var difflat = rlat2-rlat1; // Radian difference (latitudes)
        var difflon = ((+destCoord[1])-(+originCoord[1])) * (Math.PI/180); // Radian difference (longitudes)

        var d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat/2)*Math.sin(difflat/2)+Math.cos(rlat1)*Math.cos(rlat2)*Math.sin(difflon/2)*Math.sin(difflon/2)));
        return Math.round(d);
      }
    },
    calcAirTime(dist, speed) {
      let time = dist/speed;
      return Math.round((time + Number.EPSILON) * 100) / 100;
    },
    getRoundedTimeInDate(date) {
      var coff = 1000 * 60 * 5;
      return new Date(Math.ceil(
      date.getTime() / coff) * coff);
    },
    convertTime(num)
    {
      var hours = Math. floor(num / 60);
      var minutes = num % 60;
      var date = new Date();
      date.setHours(hours, minutes);
      var finalDate = this.getRoundedTimeInDate(date);
      return `${String(finalDate.getHours()).padStart(2, '0')}:${String(finalDate.getMinutes()).padStart(2, '0')} h`;
    },
  },
};
</script>

<style></style>
